// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"d42fe7d3","126":"97a458b6"}[chunkId] + ".chunk.js";
};